import { useState } from 'react';

const useModal = () => {
	const [alertModal, setAlertModal] = useState(false);

	return {
		alertModal,
		setAlertModal,
	};
};

export default useModal;
